/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Select, message, Spin, Card, Image, Button } from "antd";
import "./index.css";
import { makeRequest } from "../../services/api";
import $ from "jquery";
import tram from "../../images/tram.png";
import g_tram from "../../images/g_tram.png";
import tram_n from "../../images/tram_n.png";
import tram_b from "../../images/tram_b.png";
import truck from "../../images/truck.png";
import moment from "moment";
import { MsalLogin } from "../../services/msal";



const REFRESH_INTERVAL_IN_SECONDS = 15;

const google = window.google;
let map, marker, geocoder;
let listenerRef = null;

const allMarkers = [];

const initializeMap = (lat, lan) => {
  if (!lat) lat = 34.06471;
  if (!lan) lan = -118.19446;
  let mapOptions = {
    zoom: 18,
    center: {
      lat,
      lng: lan,
    },
    mapTypeControl: false,
  };

  geocoder = new google.maps.Geocoder();
  map = new google.maps.Map(
    document.getElementById("mapForLatLong"),
    mapOptions
  );
};

const WhiteMap = React.memo(() => {
  const { Option } = Select;
  const [vehicles, setVehicles] = useState([]);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const [state, setState] = useState({
    geofence: [],
    // vehicles: [],
    showInfoWindow: false,
    markerArr: [],
    isLoading: true,
    selectedGeofence: {},
  });

  const _subscribeToLocationUpdates = () => {
    getGeoFence();
    listenerRef = setInterval(() => {
      getGeoFence();
    }, REFRESH_INTERVAL_IN_SECONDS * 1000);
  };

  useEffect(() => {
    loadMap();
    _subscribeToLocationUpdates();
    return () => {
      clearInterval(listenerRef);
    };
  }, []);

  const update5sec = async (val) => {
    if (Object.keys(val).length > 0) {
      setState((prev) => ({
        ...prev,
        showInfoWindow: false,
        markerArr: [],
        isLoading: true,
      }));

      let vehicleList = state.vehicles;

      for (let vehicle of vehicleList) {
        vehicle["vehicle_info"] = await getVehicleInfo(vehicle.Name);
      }

      let markerArr = vehicleList.filter((item) => {
        if (
          item &&
          item.hasOwnProperty("vehicle_info") &&
          item["vehicle_info"] !== null &&
          item["vehicle_info"]["GeoFenceName"] &&
          item["vehicle_info"]["GeoFenceName"] !== null &&
          item["vehicle_info"]["GeoFenceName"]
            .toLowerCase()
            .includes(val["GeoFenceName"].toLowerCase())
        ) {
          return item;
        }
      });

      setState((prev) => ({
        ...prev,
        isLoading: false,
        markerArr: markerArr,
      }));

      addMarkers(markerArr);
    }
  };

  const loadMap = () => {
    google.maps.event.addDomListener(
      window,
      "load",
      initializeMap(34.06471, -118.19446)
    );
  };

  const addMarkers = (locations) => {
    for (let [i, location] of locations.entries()) {
     /* if (i == 0) {
        map.setCenter({
          lat: Number(location.vehicle_info.Latitude),
          lng: Number(location.vehicle_info.Longitude),
        });
      }*/

      const icon = {
        url: tram_n, //tram,
        scaledSize: new google.maps.Size(30, 30),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0),
      };

      let marker = new google.maps.Marker({
        position: {
          lat: location.vehicle_info.Latitude,
          lng: location.vehicle_info.Longitude,
        },
        map,
        draggable: false,
        icon: icon,
      });

      allMarkers.push(marker);

      let infowindow = new google.maps.InfoWindow({
        content: `
                    <div class="info_box">
                        <div class="d-flex justify-content-start align-items-center p-1 border-bottom">
                            <div class="logo">
                                <Image preview={false} src=${tram_b} width=${35} />
                            </div>
                            <div class="content">${
                              location.Vechicle_Number
                            }</div>
                        </div>
                        <div class="vehicleInfo p-1">
                            <p className='mb-0'>${
                              location.vehicle_info.GeoFenceName
                            }</p>
                            <p className='mb-0'>${
                              location.vehicle_info.Address.AddressLine1
                            }</p>
                        </div>
                    </div>
                `,
      });

      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  };

  const _resetMarkers = () => {
    for (let i = 0; i < allMarkers.length; i++) {
      allMarkers[i].setMap(null);
    }
  };

  const getGeoFence = async () => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/locations/vehicles";
      
      const response = await makeRequest("get", url);
      _resetMarkers();


      if (response) {
        let geofenceResp = response.data;

        setVehicles(geofenceResp);

        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));

        addMarkers(geofenceResp);

        return geofenceResp;
      }
    } catch (err) {
      return message.error(err.message);
    }
  };

  const getVehicleInfo = async (vehicleId) => {
    try {
      let url = `https://app-appdev-qa-verizon-gps.azurewebsites.net/api/vehicles/location/${vehicleId}?code=yaBq27foup/uuhhMomtiNxuozOM/Urr9Gtu4TZyKLDrEsuIlcp3W2g==`;

      const response = await makeRequest("get", url);

      if (response) {
        setState((prev) => ({
          ...prev,
          vehicles: JSON.parse(response),
        }));

        console.log(vehicles, "vehicles");

        return JSON.parse(response);
      }
    } catch (err) {
      return message.error(err);
    }
  };

  const handleClick = async (evt) => {
    setIsMobileDrawerOpen(false);
    await addMarkers(vehicles);

    map.setCenter({
      lat: Number(evt.vehicle_info.Latitude),
      lng: Number(evt.vehicle_info.Longitude),
    });

    map.setZoom(20);

    const icon = {
      url: tram_b, //tram,
      scaledSize: new google.maps.Size(30, 30),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0),
    };

    let marker = new google.maps.Marker({
      position: {
        lat: evt.vehicle_info.Latitude,
        lng: evt.vehicle_info.Longitude,
      },
      map,
      draggable: false,
      icon: icon,
    });

    let infowindow = new google.maps.InfoWindow({
      content: `
                <div class="info_box">
                    <div class="d-flex justify-content-start align-items-center p-1 border-bottom">
                        <div class="logo">
                            <Image preview={false} src=${tram_b} width=${35} />
                        </div>
                        <div class="content">${evt.Vechicle_Number}</div>
                    </div>
                    <div class="vehicleInfo">          
                        <p className='mb-0'>${evt.vehicle_info.GeoFenceName}</p>
                        <p className='mb-0'>${
                          evt.vehicle_info.Address.AddressLine1
                        }</p>
                    </div>
                </div>
            `,
    });

    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  };

  return (
    <Container fluid className="p-0" style={{ height: "100%" }}>
      <Row className="">
        <Spin spinning={state.isLoading} tip="fetching vehicle locations...">
          <Col xs={12} md={12} xl={12} sm={12}>
            <div className="w-100 position-relative">
              <div id="mapForLatLong"></div>
              <div id="mobileSelector" onClick={e => setIsMobileDrawerOpen(true)}>
<Image
                    preview={false}
                    src={truck}
                    width={35}
                    onClick={(e) => {
                      map.setZoom(17);
                      addMarkers(vehicles);
                    }}
                    style={{ cursor: "pointer" }}
                  />
              </div>
              <div  id="overlap_map" className={` ${isMobileDrawerOpen && 'mobileOpen'}`}>
                <Card
                  bordered={false}
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    fontSize: "12px",
                    padding: "0.5rem",
                  }}
                >
                  <div className="mobileDrawerClose" onClick={e => setIsMobileDrawerOpen(false)}>x</div>
                  <Image
                    preview={false}
                    src={truck}
                    width={35}
                    onClick={(e) => {
                      map.setZoom(17);
                      addMarkers(vehicles);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </Card>
                {vehicles.length > 0 ? (
                  vehicles.map((item) => {
                    const updateMoment = moment(item.vehicle_info.UpdateUTC);
                    const currentMoment = moment();                 
                    const wasUpdatedInLastHour = currentMoment.diff(updateMoment, 'hours') < 1;
                
                    if (wasUpdatedInLastHour) {
                      return (
                        <Card
                          title={item.Vechicle_Number}
                          size={"small"}
                          bordered={true}
                          style={{
                            width: "100%",
                            cursor: "pointer",
                            fontSize: "12px",
                          }}
                          onClick={(e) => handleClick(item)}
                        >
                          <p className="mb-0">Currently at {item.vehicle_info.GeoFenceName}</p>
                          <p className="mb-0">
                            {item.vehicle_info.Address.AddressLine1}                
                          </p>
                        </Card>
                      );
                    }
                    return null;
                  })
                ) : (
                  <div className="d-flex justify-content-center align-items-center position-relative h-100">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Spin>
      </Row>
    </Container>
  );
});

export default WhiteMap;
